import { useEffectOnceOnMount } from '../hooks/useEffectOnceOnCondition';
import { TrackingEvent } from './TrackingEvent';
import { useAnalytics } from './useAnalytics';

/** Emits the INITIAL_PAGE_LOAD event exactly once. */
export const InitialPageLoadEvent = () => {
  const { trackEvent } = useAnalytics();

  useEffectOnceOnMount(() => {
    trackEvent(TrackingEvent.INITIAL_PAGE_LOAD);
  });

  return null;
};
